import { render, staticRenderFns } from "./DurationAnalysisReport.vue?vue&type=template&id=8cbbc298&scoped=true&"
import script from "./DurationAnalysisReport.vue?vue&type=script&lang=js&"
export * from "./DurationAnalysisReport.vue?vue&type=script&lang=js&"
import style0 from "./DurationAnalysisReport.vue?vue&type=style&index=0&id=8cbbc298&scoped=true&lang=css&"
import style1 from "./DurationAnalysisReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbbc298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
